export default [
  {
    path: '/products',
    name: 'products',
    component: () =>
      import(/* webpackChunkName: "products" */
        /* webpackMode: "lazy" */
        `./views/ProductList.vue`)
  },
  {
    path: '/products/:id',
    name: 'single-product',
    component: () =>
      import(/* webpackChunkName: "products" */
        /* webpackMode: "lazy" */
        `./views/ProductItem.vue`)
  },
  {
    path: '/taxonomy',
    name: 'taxonomy',
    component: () =>
      import(/* webpackChunkName: "products" */
        /* webpackMode: "lazy" */
        `./views/TaxonomyList.vue`)
  },
  {
    path: '/taxonomy/:id',
    name: 'single-taxonomy',
    component: () =>
      import(/* webpackChunkName: "products" */
        /* webpackMode: "lazy" */
        `./views/TaxonomyItem.vue`)
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () =>
      import(/* webpackChunkName: "products" */
        /* webpackMode: "lazy" */
        `./views/ProductsInventory.vue`)
  }
]
